import useAttendanceSummary from "../../../hooks/use-attendance-summary";

import { MemberAttendanceSummary } from "../../../service/model/attendance.model";
import MemberAttendanceSummaryView from "./member-attendance-summary";
import "react-calendar/dist/Calendar.css";
import { useEffect } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { fetchAttendancesPage } from "../attendance.slice";
import { subDays } from "date-fns";

const MemberAttendance = () => {
    const dispatch = useAppDispatch();

    const attendanceSummary = useAttendanceSummary();

    useEffect(() => {
        dispatch(fetchAttendancesPage(
            {
                pagination: { page: 0, size: 30 },
                name: '',
                from: subDays(new Date(), 27).toISOString().slice(0, 10), // last 28 days
                to: new Date().toISOString().slice(0, 10),
            }
        ));
    }, []);


    return (
        <div>
            <MemberAttendanceSummaryView attendanceSummary={attendanceSummary as MemberAttendanceSummary} />
        </div>
    )
}

export default MemberAttendance;